import ProfileComponent from '../components/profile/profile'

const Profile = () => <ProfileComponent />

export default Profile;